/**
 * 全局公共方法
 */
import setters from '@/config';
import store from './store/index'
import CheckForm from '@/utils/CheckForm'


/**
 * 常用工具类统一管理
 */



var tableName = setters.tableName;
// 窗口相关
const windowSome = {
  // 获取地址栏所有参数
  oneValues() {
    var query = location.search.substr(1)
    query = query.split('&')
    var params = {}
    for (let i = 0; i < query.length; i++) {
      let q = query[i].split('=')
      if (q.length === 2) {
        params[q[0]] = q[1]
      }
    }
    return params  //返回?号后面的参数名与参数值的数组
  },
  /**
   * json转url
   * @param {*} json 
   */
  jsonToUrl(json) {
    return Object.keys(json).map(function (key) {
      // body...
      return key + "=" + json[key];
    }).join("&");
  },
  /**
   * url参数转json
   */
  urlToJson(url) {
    var hash;
    var myJson = {};
    var hashes = url.slice(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      myJson[hash[0]] = hash[1];
    }
    return myJson;
  },
  /**
   * copy sku
   */
  copyUrl(data) {
    let url = data;
    let oInput = document.createElement('input');
    oInput.value = url;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象;
    console.log(oInput.value)
    document.execCommand("Copy"); // 执行浏览器复制命令
    oInput.remove()
  },
}
// 本地储存
const localTable = {
  /**
   * 获取表数据
   * @param {*} item 
   */
  getTableItem(item) {
    var val = localStorage.getItem(tableName);
    if (val != null) {
      val = JSON.parse(val)[item];

    }
    return val;
  },
  /**
   * 添加表数据
   * @param {*} name 
   * @param {*} value 
   */
  setTableItem(name, value) {
    var val = localStorage.getItem(tableName);
    if (val != null) {
      val = JSON.parse(val);
    } else {
      val = {};
    }
    val[name] = value;
    localStorage.setItem(tableName, JSON.stringify(val));
  },
  /**
   * 删除表数据
   * @param {*} name 
   */
  deleteTableItem(name) {
    var val = localStorage.getItem(tableName);
    if (val != null) {
      val = JSON.parse(val);
      val[name] = null;
    } else {
      val = {};
    }
    localStorage.setItem(tableName, JSON.stringify(val));
  },
};
const users = {
  //清空token,权限等信息
  clearLocalTable() {
    localTable.deleteTableItem(setters.tokenName);   //token
    store.state.user_info = null;
    // router.replace({path: "/homePage"})
  },
  // 设置token
  setToken(token) {
    return localTable.setTableItem(setters.tokenName, token);
  },
  // 获取token
  getToken() {
    return localTable.getTableItem(setters.tokenName);
  },
  //打开登录弹窗
  openWindowLogin(type = 0) {
    store.state.login_type = type;
    store.state.login_box = true;
  },
}

//分页
const setCurrentPageData = (data, page, pageSize) => {
  if (data == null || data.length == 0) {
    return data;
  }
  let begin = (page - 1) * pageSize;
  let end = page * pageSize;
  return data.slice(
    begin,
    end
  );
}
// 数字公共
const num = {
  // 数字金额格式化
  formatMoney(num) {
    return (Math.round(num * 100) / 100).toFixed(2)
  },
  // 利率格式化
  formatRate(num) {
    return (Math.round(num * 100) / 100).toFixed(2)
  },
}

export default {
  windowSome, //窗口相关
  localTable, //本地存储
  users,       //用户模块
  setCurrentPageData,     //分页
  CheckForm,
  num
};